import { Phone, MapPin, Clock, Mail } from "lucide-react";

export default function ContactSection() {
  return (
    <section id="contact" data-testid="contact-section" className="py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal reveal-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#EAB308] mb-4">
            Navštivte nás
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-semibold text-[#F0FDF4] tracking-tight">
            Kontakt
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          {/* Info */}
          <div className="space-y-10 reveal reveal-left">
            {/* Phone */}
            <div className="flex gap-5" data-testid="contact-phone">
              <div className="flex-shrink-0 w-12 h-12 rounded-sm bg-[#EAB308]/10 flex items-center justify-center">
                <Phone className="w-5 h-5 text-[#EAB308]" />
              </div>
              <div>
                <h3 className="font-['Playfair_Display'] text-lg text-[#F0FDF4] mb-1">Telefon</h3>
                <a
                  href="tel:+420733513535"
                  className="text-[#EAB308] text-xl font-bold hover:text-yellow-300 transition-colors"
                >
                  +420 733 513 535
                </a>
                <p className="text-sm text-[#94A3B8] mt-1">Rezervace pouze telefonicky</p>
              </div>
            </div>

            {/* Email */}
            <div className="flex gap-5" data-testid="contact-email">
              <div className="flex-shrink-0 w-12 h-12 rounded-sm bg-[#EAB308]/10 flex items-center justify-center">
                <Mail className="w-5 h-5 text-[#EAB308]" />
              </div>
              <div>
                <h3 className="font-['Playfair_Display'] text-lg text-[#F0FDF4] mb-1">E-mail</h3>
                <a
                  href="mailto:veranda-melnik@seznam.cz"
                  className="text-[#E2E8F0] hover:text-[#EAB308] transition-colors"
                >
                  veranda-melnik@seznam.cz
                </a>
              </div>
            </div>

            {/* Address */}
            <div className="flex gap-5" data-testid="contact-address">
              <div className="flex-shrink-0 w-12 h-12 rounded-sm bg-[#EAB308]/10 flex items-center justify-center">
                <MapPin className="w-5 h-5 text-[#EAB308]" />
              </div>
              <div>
                <h3 className="font-['Playfair_Display'] text-lg text-[#F0FDF4] mb-1">Adresa</h3>
                <p className="text-[#E2E8F0]">Legionářů 84</p>
                <p className="text-[#E2E8F0]">276 01 Mělník</p>
              </div>
            </div>

            {/* Hours */}
            <div className="flex gap-5" data-testid="contact-hours">
              <div className="flex-shrink-0 w-12 h-12 rounded-sm bg-[#EAB308]/10 flex items-center justify-center">
                <Clock className="w-5 h-5 text-[#EAB308]" />
              </div>
              <div>
                <h3 className="font-['Playfair_Display'] text-lg text-[#F0FDF4] mb-2">Otevírací doba</h3>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between gap-8">
                    <span className="text-[#94A3B8]">Po, St — Ne</span>
                    <span className="text-[#E2E8F0]">10:00 — 20:00</span>
                  </div>
                  <div className="flex justify-between gap-8">
                    <span className="text-[#94A3B8]">Út</span>
                    <span className="text-red-400">Zavřeno</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div
            className="aspect-square md:aspect-auto md:min-h-[400px] rounded-sm overflow-hidden border border-[#1D4133] reveal reveal-right"
            data-testid="map-embed"
          >
            <iframe
              src="https://maps.google.com/maps?q=Legionářů+84,+Mělník,+Czech+Republic&t=&z=16&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "400px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Veranda pod Soutokem - Legionářů 84, Mělník"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
